import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

import i18n from 'portal-base/src/decorators/i18n';

import { KiDsPwaComponent } from '../../base/ki-ds-pwa-component';
import nls from '../../locales/indexes.nls';
import style from './ki-ds-pwa-menu.css';

const NAME = 'ki-ds-pwa-menu';

@i18n(nls)
@customElement(NAME)
class KiDsPwaMenu extends KiDsPwaComponent {
    static styles = style;

    static get properties() {
        return {
            channel: { type: Object },
        };
    }

    render() {
        return html`
            <nav class="nav">
                <div class="nav-logo">
                    <img
                        src="./assets/datasphere.svg"
                        alt=""
                        @click=${() => window.open('https://www.datasphere.online/de/#menu')}
                    />
                    <div>${this.channel?.name}</div>
                </div>
            </nav>
        `;
    }
}
